import React from 'react';

function HeaderColumnIcon() {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='16'
			height='16'
			fill='none'
			viewBox='0 0 16 16'
		>
			<path
				fill='#EDF876'
				d='M12 2a2 2 0 012 2v8a2 2 0 01-2 2h-1a1 1 0 01-1-1V3a1 1 0 011-1h1z'
			></path>
			<path
				stroke='#141414'
				strokeLinecap='round'
				strokeLinejoin='round'
				d='M2.594 2.594c.928-.927 2.42-.927 5.406-.927 2.986 0 4.478 0 5.406.927.927.928.927 2.42.927 5.406 0 2.986 0 4.478-.927 5.406-.928.927-2.42.927-5.406.927-2.986 0-4.478 0-5.406-.927-.927-.928-.927-2.42-.927-5.406 0-2.986 0-4.478.927-5.406z'
			></path>
			<path stroke='#141414' d='M10 1.667v12.666M6 1.667v12.666'></path>
		</svg>
	);
}

export default HeaderColumnIcon;
